












import { Component, Mixins } from "vue-property-decorator";

// Mixins
import SupportTicketInjectorMixin from "@/mixins/supportTicketInjectorMixin";

@Component({
  components: {
    "ticket-feed-provider": () =>
      import("@/components/app/global/tickets/ticketFeedProvider.vue"),
    "ticket-messages": () =>
      import("@/components/app/global/tickets/ticketMessages.vue"),
    "ticket-message-form": () =>
      import("@/components/app/global/tickets/ticketMessageForm.vue")
  }
})
export default class ClientTicketFeed extends Mixins(
  SupportTicketInjectorMixin
) {}
